export default __webpack_public_path__ + "static/media/willie.ef75d4e1.jpg";